// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file src/protos/auth/v1/auth.proto (syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file src/protos/auth/v1/auth.proto.
 */
export const file_src_protos_auth_v1_auth: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message LoginRequest
 */
export type LoginRequest = Message<"LoginRequest"> & {
  /**
   * @generated from oneof LoginRequest.identifier
   */
  identifier: {
    /**
     * @generated from field: string email = 1;
     */
    value: string;
    case: "email";
  } | {
    /**
     * @generated from field: string phoneNumber = 2;
     */
    value: string;
    case: "phoneNumber";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string password = 3;
   */
  password: string;
};

/**
 * Describes the message LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 0);

/**
 * @generated from message LoginResponse
 */
export type LoginResponse = Message<"LoginResponse"> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: optional string details = 3;
   */
  details?: string;

  /**
   * @generated from field: optional string token = 4;
   */
  token?: string;

  /**
   * @generated from field: optional string refreshToken = 5;
   */
  refreshToken?: string;
};

/**
 * Describes the message LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 1);

/**
 * @generated from message RefreshTokenRequest
 */
export type RefreshTokenRequest = Message<"RefreshTokenRequest"> & {
  /**
   * @generated from field: string refreshToken = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message RefreshTokenRequest.
 * Use `create(RefreshTokenRequestSchema)` to create a new message.
 */
export const RefreshTokenRequestSchema: GenMessage<RefreshTokenRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 2);

/**
 * @generated from message LogoutRequest
 */
export type LogoutRequest = Message<"LogoutRequest"> & {
  /**
   * @generated from field: optional string refreshToken = 1;
   */
  refreshToken?: string;
};

/**
 * Describes the message LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 3);

/**
 * @generated from message LogoutResponse
 */
export type LogoutResponse = Message<"LogoutResponse"> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;
};

/**
 * Describes the message LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 4);

/**
 * @generated from message ValidateResponse
 */
export type ValidateResponse = Message<"ValidateResponse"> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: optional bool isValid = 3;
   */
  isValid?: boolean;
};

/**
 * Describes the message ValidateResponse.
 * Use `create(ValidateResponseSchema)` to create a new message.
 */
export const ValidateResponseSchema: GenMessage<ValidateResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 5);

/**
 * @generated from message GenerateTotpInfoResponse
 */
export type GenerateTotpInfoResponse = Message<"GenerateTotpInfoResponse"> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: optional string qrUri = 3;
   */
  qrUri?: string;
};

/**
 * Describes the message GenerateTotpInfoResponse.
 * Use `create(GenerateTotpInfoResponseSchema)` to create a new message.
 */
export const GenerateTotpInfoResponseSchema: GenMessage<GenerateTotpInfoResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 6);

/**
 * @generated from message DisableTotpRequest
 */
export type DisableTotpRequest = Message<"DisableTotpRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message DisableTotpRequest.
 * Use `create(DisableTotpRequestSchema)` to create a new message.
 */
export const DisableTotpRequestSchema: GenMessage<DisableTotpRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 7);

/**
 * @generated from message VerifyTotpRequest
 */
export type VerifyTotpRequest = Message<"VerifyTotpRequest"> & {
  /**
   * @generated from field: optional string token = 1;
   */
  token?: string;

  /**
   * @generated from field: string code = 2;
   */
  code: string;

  /**
   * @generated from field: optional string phoneNumber = 3;
   */
  phoneNumber?: string;

  /**
   * @generated from field: optional string email = 4;
   */
  email?: string;
};

/**
 * Describes the message VerifyTotpRequest.
 * Use `create(VerifyTotpRequestSchema)` to create a new message.
 */
export const VerifyTotpRequestSchema: GenMessage<VerifyTotpRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 8);

/**
 * @generated from message VerifyTotpResponse
 */
export type VerifyTotpResponse = Message<"VerifyTotpResponse"> & {
  /**
   * @generated from field: optional string code = 1;
   */
  code?: string;

  /**
   * @generated from field: optional string message = 2;
   */
  message?: string;

  /**
   * @generated from field: optional string token = 3;
   */
  token?: string;

  /**
   * @generated from field: optional string refreshToken = 4;
   */
  refreshToken?: string;
};

/**
 * Describes the message VerifyTotpResponse.
 * Use `create(VerifyTotpResponseSchema)` to create a new message.
 */
export const VerifyTotpResponseSchema: GenMessage<VerifyTotpResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 9);

/**
 * @generated from message GetAuthenticatorsResponse
 */
export type GetAuthenticatorsResponse = Message<"GetAuthenticatorsResponse"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: repeated string authenticators = 3;
   */
  authenticators: string[];
};

/**
 * Describes the message GetAuthenticatorsResponse.
 * Use `create(GetAuthenticatorsResponseSchema)` to create a new message.
 */
export const GetAuthenticatorsResponseSchema: GenMessage<GetAuthenticatorsResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 10);

/**
 * @generated from message TotpResponse
 */
export type TotpResponse = Message<"TotpResponse"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message TotpResponse.
 * Use `create(TotpResponseSchema)` to create a new message.
 */
export const TotpResponseSchema: GenMessage<TotpResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 11);

/**
 * @generated from message ChangePasswordRequest
 */
export type ChangePasswordRequest = Message<"ChangePasswordRequest"> & {
  /**
   * @generated from field: string currentPassword = 1;
   */
  currentPassword: string;

  /**
   * @generated from field: string newPassword = 2;
   */
  newPassword: string;

  /**
   * @generated from field: optional string totpCode = 3;
   */
  totpCode?: string;
};

/**
 * Describes the message ChangePasswordRequest.
 * Use `create(ChangePasswordRequestSchema)` to create a new message.
 */
export const ChangePasswordRequestSchema: GenMessage<ChangePasswordRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 12);

/**
 * @generated from message ChangePasswordResponse
 */
export type ChangePasswordResponse = Message<"ChangePasswordResponse"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message ChangePasswordResponse.
 * Use `create(ChangePasswordResponseSchema)` to create a new message.
 */
export const ChangePasswordResponseSchema: GenMessage<ChangePasswordResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 13);

/**
 * @generated from message EmailManagerRequest
 */
export type EmailManagerRequest = Message<"EmailManagerRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;
};

/**
 * Describes the message EmailManagerRequest.
 * Use `create(EmailManagerRequestSchema)` to create a new message.
 */
export const EmailManagerRequestSchema: GenMessage<EmailManagerRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 14);

/**
 * @generated from message EmailManagerResponse
 */
export type EmailManagerResponse = Message<"EmailManagerResponse"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message EmailManagerResponse.
 * Use `create(EmailManagerResponseSchema)` to create a new message.
 */
export const EmailManagerResponseSchema: GenMessage<EmailManagerResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 15);

/**
 * @generated from message ConfirmEmailRequest
 */
export type ConfirmEmailRequest = Message<"ConfirmEmailRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string token = 2;
   */
  token: string;
};

/**
 * Describes the message ConfirmEmailRequest.
 * Use `create(ConfirmEmailRequestSchema)` to create a new message.
 */
export const ConfirmEmailRequestSchema: GenMessage<ConfirmEmailRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 16);

/**
 * @generated from message SendWhatsAppRequest
 */
export type SendWhatsAppRequest = Message<"SendWhatsAppRequest"> & {
  /**
   * @generated from field: string phoneNumber = 1;
   */
  phoneNumber: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: string imageUrl = 3;
   */
  imageUrl: string;
};

/**
 * Describes the message SendWhatsAppRequest.
 * Use `create(SendWhatsAppRequestSchema)` to create a new message.
 */
export const SendWhatsAppRequestSchema: GenMessage<SendWhatsAppRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 17);

/**
 * @generated from message SendWhatsAppReply
 */
export type SendWhatsAppReply = Message<"SendWhatsAppReply"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message SendWhatsAppReply.
 * Use `create(SendWhatsAppReplySchema)` to create a new message.
 */
export const SendWhatsAppReplySchema: GenMessage<SendWhatsAppReply> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 18);

/**
 * @generated from message SendWhatsAppVerificationRequest
 */
export type SendWhatsAppVerificationRequest = Message<"SendWhatsAppVerificationRequest"> & {
  /**
   * @generated from field: string phoneNumber = 1;
   */
  phoneNumber: string;
};

/**
 * Describes the message SendWhatsAppVerificationRequest.
 * Use `create(SendWhatsAppVerificationRequestSchema)` to create a new message.
 */
export const SendWhatsAppVerificationRequestSchema: GenMessage<SendWhatsAppVerificationRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 19);

/**
 * @generated from message SendWhatsAppVerificationReply
 */
export type SendWhatsAppVerificationReply = Message<"SendWhatsAppVerificationReply"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message SendWhatsAppVerificationReply.
 * Use `create(SendWhatsAppVerificationReplySchema)` to create a new message.
 */
export const SendWhatsAppVerificationReplySchema: GenMessage<SendWhatsAppVerificationReply> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 20);

/**
 * @generated from message ConfirmWhatsAppVerificationRequest
 */
export type ConfirmWhatsAppVerificationRequest = Message<"ConfirmWhatsAppVerificationRequest"> & {
  /**
   * @generated from field: string code = 2;
   */
  code: string;
};

/**
 * Describes the message ConfirmWhatsAppVerificationRequest.
 * Use `create(ConfirmWhatsAppVerificationRequestSchema)` to create a new message.
 */
export const ConfirmWhatsAppVerificationRequestSchema: GenMessage<ConfirmWhatsAppVerificationRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 21);

/**
 * @generated from message ConfirmWhatsAppVerificationReply
 */
export type ConfirmWhatsAppVerificationReply = Message<"ConfirmWhatsAppVerificationReply"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message ConfirmWhatsAppVerificationReply.
 * Use `create(ConfirmWhatsAppVerificationReplySchema)` to create a new message.
 */
export const ConfirmWhatsAppVerificationReplySchema: GenMessage<ConfirmWhatsAppVerificationReply> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 22);

/**
 * @generated from message SendPhoneNumberCodeResponse
 */
export type SendPhoneNumberCodeResponse = Message<"SendPhoneNumberCodeResponse"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message SendPhoneNumberCodeResponse.
 * Use `create(SendPhoneNumberCodeResponseSchema)` to create a new message.
 */
export const SendPhoneNumberCodeResponseSchema: GenMessage<SendPhoneNumberCodeResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 23);

/**
 * @generated from message ConfirmPhoneNumberResponse
 */
export type ConfirmPhoneNumberResponse = Message<"ConfirmPhoneNumberResponse"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message ConfirmPhoneNumberResponse.
 * Use `create(ConfirmPhoneNumberResponseSchema)` to create a new message.
 */
export const ConfirmPhoneNumberResponseSchema: GenMessage<ConfirmPhoneNumberResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 24);

/**
 * @generated from message ConfirmPhoneNumberRequest
 */
export type ConfirmPhoneNumberRequest = Message<"ConfirmPhoneNumberRequest"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message ConfirmPhoneNumberRequest.
 * Use `create(ConfirmPhoneNumberRequestSchema)` to create a new message.
 */
export const ConfirmPhoneNumberRequestSchema: GenMessage<ConfirmPhoneNumberRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 25);

/**
 * @generated from message ForgotPasswordRequest
 */
export type ForgotPasswordRequest = Message<"ForgotPasswordRequest"> & {
  /**
   * @generated from field: optional string email = 1;
   */
  email?: string;

  /**
   * @generated from field: optional string phoneNumber = 2;
   */
  phoneNumber?: string;
};

/**
 * Describes the message ForgotPasswordRequest.
 * Use `create(ForgotPasswordRequestSchema)` to create a new message.
 */
export const ForgotPasswordRequestSchema: GenMessage<ForgotPasswordRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 26);

/**
 * @generated from message ForgotPasswordResponse
 */
export type ForgotPasswordResponse = Message<"ForgotPasswordResponse"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message ForgotPasswordResponse.
 * Use `create(ForgotPasswordResponseSchema)` to create a new message.
 */
export const ForgotPasswordResponseSchema: GenMessage<ForgotPasswordResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 27);

/**
 * @generated from message ResetPasswordRequest
 */
export type ResetPasswordRequest = Message<"ResetPasswordRequest"> & {
  /**
   * @generated from field: optional string email = 1;
   */
  email?: string;

  /**
   * @generated from field: optional string phoneNumber = 2;
   */
  phoneNumber?: string;

  /**
   * @generated from field: optional string token = 3;
   */
  token?: string;

  /**
   * @generated from field: optional string code = 4;
   */
  code?: string;

  /**
   * @generated from field: optional string whatsAppCode = 5;
   */
  whatsAppCode?: string;

  /**
   * @generated from field: string newPassword = 6;
   */
  newPassword: string;
};

/**
 * Describes the message ResetPasswordRequest.
 * Use `create(ResetPasswordRequestSchema)` to create a new message.
 */
export const ResetPasswordRequestSchema: GenMessage<ResetPasswordRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 28);

/**
 * @generated from message ResetPasswordResponse
 */
export type ResetPasswordResponse = Message<"ResetPasswordResponse"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message ResetPasswordResponse.
 * Use `create(ResetPasswordResponseSchema)` to create a new message.
 */
export const ResetPasswordResponseSchema: GenMessage<ResetPasswordResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 29);

/**
 * @generated from message ResetPassValidationTypeRequest
 */
export type ResetPassValidationTypeRequest = Message<"ResetPassValidationTypeRequest"> & {
  /**
   * @generated from field: string phoneNumber = 1;
   */
  phoneNumber: string;

  /**
   * @generated from field: string validationType = 2;
   */
  validationType: string;
};

/**
 * Describes the message ResetPassValidationTypeRequest.
 * Use `create(ResetPassValidationTypeRequestSchema)` to create a new message.
 */
export const ResetPassValidationTypeRequestSchema: GenMessage<ResetPassValidationTypeRequest> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 30);

/**
 * @generated from message ResetPassValidationTypeResponse
 */
export type ResetPassValidationTypeResponse = Message<"ResetPassValidationTypeResponse"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message ResetPassValidationTypeResponse.
 * Use `create(ResetPassValidationTypeResponseSchema)` to create a new message.
 */
export const ResetPassValidationTypeResponseSchema: GenMessage<ResetPassValidationTypeResponse> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 31);

/**
 * @generated from message Empty
 */
export type Empty = Message<"Empty"> & {
};

/**
 * Describes the message Empty.
 * Use `create(EmptySchema)` to create a new message.
 */
export const EmptySchema: GenMessage<Empty> = /*@__PURE__*/
  messageDesc(file_src_protos_auth_v1_auth, 32);

/**
 * @generated from service AuthData
 */
export const AuthData: GenService<{
  /**
   * @generated from rpc AuthData.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc AuthData.RefreshSession
   */
  refreshSession: {
    methodKind: "unary";
    input: typeof RefreshTokenRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc AuthData.GlobalLogout
   */
  globalLogout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * @generated from rpc AuthData.LocalLogout
   */
  localLogout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
  /**
   * @generated from rpc AuthData.ValidateSession
   */
  validateSession: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ValidateResponseSchema;
  },
  /**
   * @generated from rpc AuthData.GenerateTOTPInfo
   */
  generateTOTPInfo: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GenerateTotpInfoResponseSchema;
  },
  /**
   * @generated from rpc AuthData.EnableTOTP
   */
  enableTOTP: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof TotpResponseSchema;
  },
  /**
   * @generated from rpc AuthData.DisableTOTP
   */
  disableTOTP: {
    methodKind: "unary";
    input: typeof DisableTotpRequestSchema;
    output: typeof TotpResponseSchema;
  },
  /**
   * @generated from rpc AuthData.VerifyTOTP
   */
  verifyTOTP: {
    methodKind: "unary";
    input: typeof VerifyTotpRequestSchema;
    output: typeof VerifyTotpResponseSchema;
  },
  /**
   * @generated from rpc AuthData.GetAuthenticators
   */
  getAuthenticators: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetAuthenticatorsResponseSchema;
  },
  /**
   * @generated from rpc AuthData.ChangePassword
   */
  changePassword: {
    methodKind: "unary";
    input: typeof ChangePasswordRequestSchema;
    output: typeof ChangePasswordResponseSchema;
  },
  /**
   * @generated from rpc AuthData.SendEmailVerification
   */
  sendEmailVerification: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof EmailManagerResponseSchema;
  },
  /**
   * @generated from rpc AuthData.ConfirmEmail
   */
  confirmEmail: {
    methodKind: "unary";
    input: typeof ConfirmEmailRequestSchema;
    output: typeof EmailManagerResponseSchema;
  },
  /**
   * @generated from rpc AuthData.SendPhoneNumberVerificationCode
   */
  sendPhoneNumberVerificationCode: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof SendPhoneNumberCodeResponseSchema;
  },
  /**
   * @generated from rpc AuthData.ConfirmPhoneNumber
   */
  confirmPhoneNumber: {
    methodKind: "unary";
    input: typeof ConfirmPhoneNumberRequestSchema;
    output: typeof ConfirmPhoneNumberResponseSchema;
  },
  /**
   * @generated from rpc AuthData.ForgotPassword
   */
  forgotPassword: {
    methodKind: "unary";
    input: typeof ForgotPasswordRequestSchema;
    output: typeof ForgotPasswordResponseSchema;
  },
  /**
   * @generated from rpc AuthData.ResetPassValidationType
   */
  resetPassValidationType: {
    methodKind: "unary";
    input: typeof ResetPassValidationTypeRequestSchema;
    output: typeof ResetPassValidationTypeResponseSchema;
  },
  /**
   * @generated from rpc AuthData.ResetPassword
   */
  resetPassword: {
    methodKind: "unary";
    input: typeof ResetPasswordRequestSchema;
    output: typeof ResetPasswordResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_src_protos_auth_v1_auth, 0);

